import * as React from "react";
import { Button } from "@material-ui/core";
import { Helmet } from "react-helmet";
type Props = {
  id: string;
};
export default function ThetaViewer(props: Props) {
  const { id } = props;
  return (
    <>
      <blockquote
        data-width="100%"
        data-height="544"
        className="ricoh-theta-spherical-image"
      >
        <Button
          href={`https://theta360.com/s/${id}`}
          color="primary"
          target="_blank"
        >
          表示されない場合はこちらをクリック
        </Button>
      </blockquote>
      <Helmet>
        <script async src="https://theta360.com/widgets.js"></script>
      </Helmet>
    </>
  );
}
